import React from 'react';

import { ToggleButton, Section } from '@gogame/components';
import { FormField } from '@gogame/form';

import { PAY_TO, TODAY, LAST_DAY } from './constants';

const PayTo = ({ values, onChange }) => {
  const handleChange = (_e, val) => {
    let payTo = val;

    if (payTo === null) {
      payTo = values?.[PAY_TO];
    }

    onChange({
      ...values,
      [PAY_TO]: payTo,
    });
  };

  return (
    <Section title={'Pay to'}>
      <FormField.ToggleButtonGroup
        name={PAY_TO}
        exclusive={true}
        padding={0}
        onChange={handleChange}
      >
        <ToggleButton value={LAST_DAY}>Period’s last day</ToggleButton>
        <ToggleButton value={TODAY}>Today</ToggleButton>
      </FormField.ToggleButtonGroup>
    </Section>
  );
};

export default PayTo;
